<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
*, :after, :before {
    box-sizing: border-box;
}
html,body{
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    /* overflow: hidden; */
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */

}
</style>



// WEBPACK FOOTER //
// src/App.vue